import React from 'react';

import { isIosRouterTimelineMarker } from './generators/ios/IosRouterTree';
import { IosRouterTreeTooltipContent } from './generators/ios/IosRouterTreeTooltipContent';
import { TimelineMarker } from './TimelineData';

type Props = Record<string, any>;

type State = {
  markers: TimelineMarker[];

  posX: number;
  posY: number;
  visible: boolean;
};

export class TimelineTooltip extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      visible: false,
      posX: 0,
      posY: 0,
      markers: [],
    };
  }

  setVisible(v: boolean) {
    this.setState({ visible: v });
  }

  setPosition(x: number, y: number) {
    this.setState({ posX: x, posY: y });
  }

  setMarkers(markers: TimelineMarker[]) {
    this.setState({ markers });
  }

  render() {
    const style: React.CSSProperties = {
      display: this.state.visible ? 'block' : 'none',
    };

    if (this.state.posY > 0) {
      style.top = this.state.posY;
    } else {
      style.bottom = -this.state.posY;
    }

    if (this.state.posX > 0) {
      style.left = this.state.posX;
    } else {
      style.right = -this.state.posX;
    }

    const allMarkers = this.state.markers;
    let markersToInclude = allMarkers;
    if (markersToInclude.length > 3) {
      markersToInclude = markersToInclude.slice(0, 3);
    }

    return (
      <div className="timeline-tooltip" style={style}>
        {markersToInclude.map((marker, index) => {
          return (
            <React.Fragment key={marker.markerId}>
              {index > 0 ? <div className="timeline-tooltip-separator" /> : null}
              {this.markerTooltipContent(marker)}
            </React.Fragment>
          );
        })}
        {markersToInclude.length < allMarkers.length ? (
          <div>{`+ ${allMarkers.length - markersToInclude.length} more markers`}</div>
        ) : null}
      </div>
    );
  }

  private markerTooltipContent(marker: TimelineMarker): React.ReactNode {
    if (isIosRouterTimelineMarker(marker)) {
      return (
        <IosRouterTreeTooltipContent
          eventText={marker.tooltipContent || `#${marker.logEntry.index}`}
          snapshot={marker.iosRouterTreeSnapshot}
        />
      );
    }

    return marker.tooltipContent || `#${marker.logEntry.index}`;
  }
}
